const userGridData = [
    {
        id: 1,
        name: 'David McHenry',
        designation: 'UI/UX Designer',
        projects: ['Photoshop', 'illustrator'],
        email: 'david@skote.com'
    },
    {
        id: 2,
        image: require('@/assets/images/users/avatar-2.jpg'),
        name: 'Frank Kirk',
        designation: 'Frontend Developer',
        projects: ['Html', 'Css', '2 + more'],
        email: 'frank@skote.com'
    },
    {
        id: 3,
        image: require('@/assets/images/users/avatar-3.jpg'),
        name: 'Rafael Morales',
        designation: 'Backend Developer',
        projects: ['Php', 'Java', 'Python'],
        email: 'Rafael@skote.com'
    },
];

export { userGridData };